import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EChannelFields = {
	isEmail: 'isEmail',
	isNotification: 'isNotification',
	messageTitle: 'messageTitle',
	messageBody: 'messageBody',
} as const;

export type TChannelFields = TValueOfStringRecord<typeof EChannelFields>
